import {GraphEntityStatus, RelationPresentation} from '../interface';

export const nodeWidth = 169;
export const nodeHeight = 105;

export const edgePropsByType = {
    [RelationPresentation.ASSERTED]: {
        [GraphEntityStatus.default]: {
            color: '#059CDD'
        },
        [GraphEntityStatus.hovered]: {
            color: '#059CDD'
        },
        [GraphEntityStatus.selected]: {
            color: '#000000'
        }
    },
    [RelationPresentation.REACTION]: {
        [GraphEntityStatus.default]: {
            color: '#94D03C'
        },
        [GraphEntityStatus.hovered]: {
            color: '#94D03C'
        },
        [GraphEntityStatus.selected]: {
            color: '#000000'
        }
    },
    [RelationPresentation.MATCHED]: {
        [GraphEntityStatus.default]: {
            color: '#FC49A7'
        },
        [GraphEntityStatus.hovered]: {
            color: '#FC49A7'
        },
        [GraphEntityStatus.selected]: {
            color: '#000000'
        }
    }
};
